// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__WzdbL","load8":"Spinner_load8__DEFZT"};